export const updateUserOrganization = async (
    email,
    token,
    organization_name,
    organization_type,
) => {
    try {
        const confirm = await fetch(
            `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}/user/update?email=${encodeURIComponent(email)}`,
            {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ organization_name, organization_type }),
            },
        );
        const responseText = await confirm.text();

        if (!confirm.ok) {
            throw new Error(
                `HTTP error! status: ${confirm.status}, body: ${responseText}`,
            );
        }
        return JSON.parse(responseText);
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};
